import { HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-new-field-snimei-admin-config',
  templateUrl: './new-field-snimei-admin-config.component.html',
  styleUrls: ['./new-field-snimei-admin-config.component.scss']
})
export class AtwNewFieldSnimeiAdminConfig  extends AtwUpdateDbComponent  implements OnInit {
@Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() data: any;
  categories: Array<any> = [];
  productList: any[] = []; // Danh sách sản phẩm
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  showProduct: any = []; // Danh sách sản phẩm hiển thị
  id_category = 'all'; // get những sp theo danh mục
  newFields = [];
  addProductForm: FormGroup;
  doneLoad = false;
  dataType : string = "";
  lookupGroupArray = [1,2,3,4,5,6,7,8,9,10]
  display_types=[{value: 'input', label: 'Ô nhập'}, {value: 'text', label: 'Văn bản'}]
  styles_field = [
    {
      title: 'hieu_ung',
      index: 1,
    },
    {
      title: 'bo_tron',
      index: 2,
    }
  ];
  configMode: 'basic' | 'advanced' = 'basic';
  fonts = [];
  effect_hover = [];
  effect_hover_data: any = {};
  text_style: any = [
    {
      title: 'Tiêu đề 1',
      fontSize: '68px',
      name: 'h1',
      font: 21
    },
    {
      title: 'Tiêu đề 2',
      fontSize: '48px',
      name: 'h2',
      font: 19
    },
    {
      title: 'Tiêu đề 3',
      fontSize: '36px',
      name: 'h3',
      font: 18
    },
    {
      title: 'Tiêu đề 4',
      fontSize: '26px',
      name: 'h4',
      font: 17
    },
    {
      title: 'Tiêu đề 5',
      fontSize: '20px',
      name: 'h5',
      font: 16
    },
    {
      title: 'Tiêu đề 6',
      fontSize: '18px',
      name: 'h6',
      font: 15
    },
    {
      title: 'Văn bản',
      fontSize: '18px',
      name: 'p',
      font: 14
    },
    {
      title: 'van_ban_quan_trong',
      fontSize: '18px',
      name: 'strong',
      font: 14
    },
    {
      title: 'Văn bản nhỏ',
      fontSize: '16px',
      name: 'small',
      font: 13
    },
    {
      title: 'Trích dẫn',
      fontSize: '18px',
      name: 'Blockquote',
      font: 14
    }
  ];
  /** Danh sách giải thích loại văn bản tương ứng SEO */
  seoTextTypes: any = [
    { tag: 'tieu_de_1', explain: 'dung_cho_tieu_de_chinh', usage: 'chi_dung_mot_lan_trong_trang' },
    { tag: 'tieu_de_2_den_tieu_de_6', explain: 'dung_cho_cac_tieu_de_phu', usage: 'dung_theo_thu_tu_phan_cap_khong_bo_bac' },
    { tag: 'van_ban', explain: 'dung_cho_van_ban' },
    { tag: 'van_ban_quan_trong', explain: 'dung_cho_van_ban', usage: 'chi_de_nhan_y_quan_trong_dung_tiet_che' },
  ];
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'Mặc định',
      img: '../../../../../assets/root/icon/user/gdDefault.png',
      deg: '180deg'
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'Từ trái sang phải',
      img: '../../../../../assets/root/icon/user/gdToRight.png',
      deg: '90deg'
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'Từ phải sang trái',
      img: '../../../../../assets/root/icon/user/gdToLeft.png',
      deg: '270deg'
    },
  ];
  arr_link_page: any;
  id_subproject: any = "";
  selectedValue: string;
  backgroundColors

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private route: ActivatedRoute,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    this.getNewFileds(this.staticdata.type);
    this.getLinkAllPages();



    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/text.json'),
      this.http.get('assets/background-colors/background-colors.json'),

    ]).subscribe(([fonts, effects, backgroundColors]: any) => {
      this.fonts = fonts;
      this.effect_hover = effects;
      this.backgroundColors = backgroundColors;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    })
  }

  ngOnChanges(): void {
    this.getLinkAllPages();

    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }


  /**
   * Cập nhật transform
   */
  handleSetTextRotate() {
    this.class['text__content']['transform'] = `rotate(${this.config['transform']['rotate']}deg)`;
  }
  /**
   * Cập nhật các thuộc tính border-radius
   */
  handleSetBorderRadius() {
    this.class['text__wrapper']['border-top-left-radius'] = this.class['text__wrapper']['border-radius'];
    this.class['text__wrapper']['border-top-right-radius'] = this.class['text__wrapper']['border-radius'];
    this.class['text__wrapper']['border-bottom-left-radius'] = this.class['text__wrapper']['border-radius'];
    this.class['text__wrapper']['border-bottom-right-radius'] = this.class['text__wrapper']['border-radius'];
    this.updateClass();
  }

  /**
   * Cập nhật Kiểu văn bản
   */
  handleSetTextStyle(action) {
    this.class['text__content']['font-size'] = this.text_style.find(style => style.name === action)['fontSize'];
    switch (action) {
      case "Blockquote":
        this.class['text__content']['border-left-width'] = '10px';
        this.class['text__content']['padding-left'] = '10px';
        break;
      default:
        this.class['text__content']['border-left-width'] = '0';
        this.class['text__content']['padding-left'] = '0';
    }

    this.handleSetCurveText();

    this.updateObject();
  }

  /**
   * Cập nhật Kiểu danh sách đầu dòng, đánh số
   */
  handleListStyle(style: string) {
    if (`${style} inside none` === this.class['text__content--list-style']['list-style']) {
      style = "none";
      this.config['text_type'] = 'p';
    }
    else {
      this.config['text_type'] = 'ul';
    }

    switch (style) {
      case 'disc':
      case 'decimal':
      case 'upper-alpha':
      case 'upper-roman':
        this.class['text__content']['flex-direction'] = 'column';
        this.class['text__content--list-style']['list-style'] = `${style} inside none`;
        break;
      default:
        this.class['text__content']['flex-direction'] = 'row';
        this.class['text__content--list-style']['list-style'] = 'none';
    }

    this.updateObject();
  }
  /**
   * Xử lý kiểu Uốn cong
   */
  handleSetCurveText() {
    var radius = this.config['curve']['radius'] * 1;

    this.class['text__curve-item']['background-image'] = this.class['text__content']['background-image'];
    this.class['text__curve-item']['-webkit-text-fill-color'] = this.class['text__content']['-webkit-text-fill-color'];
    this.class['text__curve-item']['-webkit-background-clip'] = this.class['text__content']['-webkit-background-clip'];
    this.class['text__curve-item']['height'] = radius + 'px';

    this.class['text__curve']['height'] = (radius * 2) + 'px';
    this.class['text__curve']['width'] = (radius * 2) + 'px';
  }

  // GRADIENT
  /**
   * Cập nhật Gradient
   */
  handleSetGradientText() {
    if (this.config['background-image']['gradient_check']) {
      this.class['text__content']['background-image'] = `linear-gradient(${this.config['background-image']['background_image_direction']} ${this.config['background-image']['background_image_arr_gradient']})`;
      this.class['text__content']['-webkit-text-fill-color'] = 'transparent';
      this.class['text__content']['-webkit-background-clip'] = 'text';
    }
    else {
      this.class['text__content']['background-image'] = 'none';
      this.class['text__content']['-webkit-text-fill-color'] = 'unset';
      this.class['text__content']['-webkit-background-clip'] = 'unset';
    }

    // gradient cho kiểu uốn cong
    if (this.config['curve']['isCurve']) {
      this.class['text__curve-item']['background-image'] = this.class['text__content']['background-image'];
      this.class['text__curve-item']['-webkit-text-fill-color'] = this.class['text__content']['-webkit-text-fill-color'];
      this.class['text__curve-item']['-webkit-background-clip'] = this.class['text__content']['-webkit-background-clip'];
    }

    this.updateClass();
    this.updateConfig();
  }

  openbgGradient() {
    document.getElementById('input-gradient').click();
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    this.config['background-image']['background_image_direction'] = direction.direction;
    this.handleSetGradientText();
  }
  /** Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /** Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    this.config['background-image']['background_image_opacity'] = e.target.value;
    const newArr = this.config['background-image']['background_image_arr_gradient'].map((color) => {
      const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
      return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-image']['background_image_opacity'] / 100})`
    })
    this.config['background-image']['background_image_arr_gradient'] = newArr;

    this.handleSetGradientText();
  }
  /**
  * Hàm này thực hiện thêm màu gradient vào array.
  *
  */
  addGradient() {
    this.config['background-image']['background_image_arr_gradient'].push(
      `rgba(${this.hexToRGB(this.config['background-image']['background_image_background_color'])}, ${this.config['background-image']['background_image_opacity'] / 100})`
    );
    this.handleSetGradientText();
  }
  /**  Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
  * @param index : vị trí phần tử muốn xóa
  */
  deleteGradient(index) {
    this.config['background-image']['background_image_arr_gradient'].splice(index, 1);
    this.handleSetGradientText();
  }


  // ANIMATION
  customize = []

  // /**
  //  * Hàm update object vào database.
  //  */
  // updateObject() {
  //   return this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //   .catch((err) => {
  //     console.error(err);
  //   })
  // }

  // /**
  //  * Hàm update class
  //  */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //   .catch((err) => {
  //     console.error(err);
  //   })
  // }

  // /**
  //  * Hàm update config
  //  */
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //     .then((bool: any) => {
        
  //     })
  // }

  // /**
  //  * Cập nhật staticdata vào database.
  //  */
  // updateStaticData() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
  //     .then(
  //       (bool) => {
          
  //       },
  //       (error) => {
  //         console.error(error);
  //       }
  //     );
  // }


  /**
   * Xử lý lấy link các page về.
   */
  getLinkAllPages() {
    this.vhQueryAutoWeb.getPages_byFields({ type: { $in: ['detail_product'] } })
    .then((pages) => {
      this.arr_link_page = pages;
    })
  }

  /**
   * remove link khi click vào nút x
   */
  removeLink() {
    this.staticdata.hyper_link = '';
    this.updateStaticData();
  }

  
  /**Hàm này dùng để click chọn màu nền của danh sách màu.
     * @param bgColor : trả về màu được chọn
     * @param event : trả về element được active
     */
  chooseBg(bgColor, event) {
    var activeGradient = document.querySelector('.container-color .active') as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');
    this.class[`newField__input`]['background-color'] = bgColor.bgColor;
    this.updateClass();
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };
  initForm(): void {
    this.addProductForm = new FormGroup({
      name: new FormControl('', Validators.compose([Validators.required])),
      price2: new FormControl(
        0,
        Validators.compose([
          Validators.required,
          Validators.pattern(
            '(^[0?=[.]] |^[^.,-][,0-9]*)(([.](?=[0-9]){1}[0-9]{0,5})|)'
          ),
        ])
      ),
      price: new FormControl(
        0,
        Validators.compose([
          Validators.required,
          Validators.pattern(
            '(^[0?=[.]] |^[^.,-][,0-9]*)(([.](?=[0-9]){1}[0-9]{0,5})|)'
          ),
        ])
      ),
      price_import: new FormControl(
        0,
        Validators.compose([
          Validators.required,
          Validators.pattern(
            '(^[0?=[.]] |^[^.,-][,0-9]*)(([.](?=[0-9]){1}[0-9]{0,5})|)'
          ),
        ])
      ),
      unit: new FormControl('', Validators.required),
      units: new FormControl([]),
      barcode: new FormControl(''),
      allow_sell: new FormControl(true),
      selling: new FormControl(true),
      brand: new FormControl(''),
      type: new FormControl(1),
      warning_number: new FormControl(0),
      id_category: new FormControl([]),
      manysize: new FormControl(false),
      manylot: new FormControl(false),
      days_import_warning: new FormControl(0, Validators.required),
      days_exp_warning: new FormControl(0, Validators.required),
      webapp_sort_description: new FormControl(''),
      webapp_description: new FormControl(''),
      webapp_price_sales: new FormControl(
        0,
        Validators.compose([
          Validators.pattern(
            '(^[0?=[.]] |^[^.,-][,0-9]*)(([.](?=[0-9]){1}[0-9]{0,5})|)'
          ),
        ])
      ),
      webapp_hidden: new FormControl(true),
      webapp_seo_title: new FormControl(''),
      webapp_seo_description: new FormControl(''),
      webapp_seo_keyword: new FormControl(''),

    });
    for (let i in this.newFields) {
      this.addProductForm.addControl(this.newFields[i].field_custom, new FormControl(this.newFields[i].field_start_value, [this.newFields[i].field_required ? Validators.required : Validators.nullValidator]))
    }
    this.doneLoad = true
  }
  // hàm lấy ra các fields để get các giá trị sản phẩm
  getNewFileds(type) {
    // tại vì type của đầu vào bắt buộc giá trị string tương đương là text, mà text này ảnh hưởng tới logic khác cho nên thực hiện phép
    //  gán ở đây .
    if(type == 'text'){
       type = 'string';
    }
    this.vhQueryAutoWeb.getNewFields_byFields({ id_main_sector: { $eq: this.staticdata.id_main_sector }, field_typeof: { $eq: `${type}` } })
      .then((newfields: any) => {
        this.newFields = newfields;
        this.initForm();
      });
  }
  // hàm lưu giá trị của sản phẩm khi thay đổi
  onSelectChange(field_custom: any) {
    this.staticdata.value_main_sector = field_custom;
    const findItem = this.newFields.find(e => e.field_custom == field_custom);
    if (findItem) {
      this.staticdata.field_required = findItem.field_required;
      this.staticdata.field_lable = findItem.field_lable;
    }
    this.updateStaticData();
  }
  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[0])
  }
  
  changeLookupGroup(event){
    this.staticdata.lookup_group = event;
    this.updateStaticData();
  
  }

  handleChangeType(event) {
    let dataUpdate = {
      resize_field: 'text',
      resize_group: 'text',
      staticdata: this.staticdata
    }
    if(event == 'input') {
      dataUpdate.resize_field = 'newField__input'
      dataUpdate.resize_group = 'input'
    } else {
      dataUpdate.resize_field = 'text'
      dataUpdate.resize_group = 'text'
    }

    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, dataUpdate)
  
  }
}
